module.exports = __webpack_public_path__ + "static/media/getting.41d3d8f1.png";